const menuList = [
  {
    title: '首页',
    key: '/admin/home',
    icon: 'home',
    isPublic: true,
  },
  {
    title: '客户端管理',
    key: '/admin/client',
    icon: 'robot',
  },
  {
    title: '用户管理',
    key: '/admin/user',
    icon: 'user',
  },
  {
    title: '角色管理',
    key: '/admin/role',
    icon: 'safety',
  },
  {
    title: '行业管理',
    key: '/admin/industry',
    icon: 'safety',
  },
  {
    title: '分类管理',
    key: '/admin/category',
    icon: 'safety',
  },
  {
    title: '系列管理',
    key: '/admin/series',
    icon: 'safety',
  },
  // {
  //   title: 'test',
  //   key: '/admin/test',
  //   icon: 'safety',
  // },
]

export default menuList
